import React, { useCallback, useImperativeHandle, useState } from 'react'
import PropTypes from 'prop-types'
import RoundedModal from '../../../../../molecules/RoundedModal'
import CreateQueryBlueprintForm from './form'

const CreateQueryBlueprintDialog = React.forwardRef(function CreateQueryBlueprintDialog ({ onComplete }, ref) {
  const [dialogState, setDialogState] = useState({ open: false, processing: false })

  const close = useCallback(() => {
    setDialogState({ open: false, processing: false })
  }, [setDialogState])

  const handleComplete = useCallback((e) => {
    close()
    onComplete(e)
  }, [close, onComplete])

  useImperativeHandle(ref, () => ({
    open: () => {
      setDialogState({ open: true, processing: false })
    }
  }), [setDialogState])

  return (
    <RoundedModal
      title='Create Query Blueprint'
      open={dialogState.open}
      onClose={close}
      size='large'
      position='top'
      disablePortal={false}
    >
      <div>
        {dialogState.open ? (
          <CreateQueryBlueprintForm
            onComplete={handleComplete}
            onCancel={close}
          />
        ) : null}
      </div>
    </RoundedModal>
  )
})

CreateQueryBlueprintDialog.propTypes = {
  onComplete: PropTypes.func
}

CreateQueryBlueprintDialog.defaultProps = {
  onComplete: () => {}
}

export default CreateQueryBlueprintDialog
